<template>
    <div class="phone-field" :class="{ 'ajax-processed' : ajaxProcessed, }" >
        <input size="30" type="text" inputmode="numeric" :name="name" :value="phone" :readonly="!!smsWaiting" :required="!!required" />
        <template v-if="!captchaMessage" >
            <template v-if="counter > 0" >
                <span class="message send_phone_code--phone-code-sended"  >код отправлен</span>
                <div>Повторная отправка возможна через {{ counter }} сек.</div>
            </template>
            <a v-else-if="!isPhoneConfirmed && isPhoneValid && !smsWaiting" href="#" @click.prevent="send()" class="link link--red send_phone_code">Отправить код подтверждения.</a>
            <div v-if="!isPhoneConfirmed && smsSended" class="form_row" >
                <label for="PHONE_CONFIRM_CODE">Код подтверждения</label>
                <input id="UF_PHONECONFIRM_CODE" size="30" type="text" name="UF_PHONECONFIRM_CODE" value="" class="" inputmode="numeric"/>
            </div>
        </template>
        <span v-if="captchaMessage" class="message send_phone_code--phone-code-sended"  >{{captchaMessage}}</span>
    </div>
</template>
<script>
export default {
    name: 'PhoneConfirm',
    props : {
        name : {
            type : String,
            default : '',
        },
        value : {
            type : String,
            default : '',
        },
        required : {
            type : String,
            default : '',
        },
    },
    data : () => ({
        phone : '',
        smsWaiting : false,
        smsSended : false,
        smsTimeout : null,
        smsInterval : null,
        ajaxProcessed : false,
        captchaMessage:false,//сообщение о безуспешной капче
        counter : 0,
        token:'',
        siteKey:'6Le836sUAAAAAD9cJlwzn4nSqgI381giR_Q-Tf5P'
    }),
    mounted () {
        this.phone = this.value;
        setPhoneMask($('[name="'+this.name+'"]'));
        $('[name="'+this.name+'"]').keyup((e) => {
            this.phone = $(e.currentTarget).val();
        });
        if (+vxCommonStore.state.lastPhoneConfirmTimestamp > (moment().unix() - 60)) {
            this.waitingStart();
            this.counter = moment().unix() - +vxCommonStore.state.lastPhoneConfirmTimestamp;
        }
    },
    created:function(){
        var apps=this;
        grecaptcha.ready(function()
        {
            apps.refreshToken();
            setInterval(function()
            {
                apps.refreshToken();
            },20000)
        });
    },
    computed : {
        confirmedPhones : () => vxCommonStore.state.confirmedPhones,
        isPhoneValid () {
            if (!this.phone) {
                return false;
            }
            var phone = this.phone.match(/\d+/ig).join('');
            return (phone.length == 11);
        },
        isPhoneConfirmed () {
            if (!this.phone) {
                return false;
            }
            var phone = this.phone.match(/\d+/ig).join('');
            return !!~vxCommonStore.state.confirmedPhones.indexOf(phone);
        },
    },
    watch : {
        counter (val, oldVal) {
            if (val <= 0) {
                this.waitingStop();
            }
        }
    },
    methods : {
        waitingStart () {
            this.smsSended = true;
            this.counter = 60;
            this.smsTimeout = setTimeout(
                () => {
                    this.waitingStop();
                },
                1 * 60 * 1000
            );
            this.smsInterval = setInterval(
                () => {
                    this.counter--;
                },
                1000
            );
        },
        refreshToken:function(){
            var apps = this;
            grecaptcha.execute(apps.siteKey,{action : "homepage"}).then(
                function( token )
                {
                    apps.token=token;
                });
        },
        waitingStop () {
            this.ajaxProcessed = false;
            this.smsWaiting = false;
            this.counter = 0;
            clearInterval(this.smsInterval);
            clearTimeout(this.smsTimeout);
        },
        send () {
            if (this.ajaxProcessed || this.smsWaiting) {
                return;
            }
            this.ajaxProcessed = true;
            this.smsWaiting = true;
            XPage.ajax({
                data : {
                    'ajax_command' : 'confirm_phone',
                    'request_type':'phoneConfirmComponent',
                    'phone' : this.phone,
                    'captchaToken':this.token//токен капчи
                },
                success : (response) => {                    
                    if (response.success && response.captchaResult) {
                        vxCommonStore.commit('setLastPhoneConfirmTimestamp', moment().unix());
                        this.waitingStart();
                    }
                    else if(!response.captchaResult)
                    {
                        this.captchaMessage='Проверка не пройдена. Попробуйте перезагрузить страницу или зайти с другого браузера.'
                    }else if(response.error){
                        showHeaderMessage(response.error, 'error');
                    }
                }
            });
        },
    },
}
</script>
